import { IAppState } from '../types';

export const getIsLoadingLibrariesEnabled = (
  state: IAppState
): boolean | null => state.settings.is_loading_libraries_enabled;
